<template>
  <b-modal v-model="modalVisible" centered hide-footer title="批次新增酒桶">
    <template #default>
      <div>
        <div class="step-1">
          <div class="info-window">
            <div>
              <div v-if="dataInFile.length === 0">
                <b-form-group
                  label="請選擇上傳的檔案"
                >
                  <input type="file" accept=".csv" @change="inputFileChanged"/>
                </b-form-group>
              </div>
  
              <div v-if="dataInFile.length > 0">
                <ul>
                  <li v-for="(item, index) in dataInFile" :key="index" :class="{'text-danger': item.error}">
                    <div class="row">
                      <div class="col-auto">
                        <b-icon icon="bookmark-fill" v-if="!item.error && !item.uploaded"></b-icon>
                        <b-icon icon="bookmark-x" variant="danger" v-if="item.error"></b-icon>
                        <b-icon icon="bookmark-check-fill" variant="success" v-if="!item.error && item.uploaded"></b-icon>
                      </div>
                      <div class="col" :class="{'text-danger': item.error}">
                        {{ item.kid }}({{ item.isReused? '再利用': '新品' }})
                      </div>
  
                      <div class="col-12" v-if="item.error">
                        <span class="text-danger">{{ item.errorMsg }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

            </div>
          </div>
  
          <div class="row justify-content-between">
            <div class="col-auto">
              <a href="/download/batch_sample.csv" download>下載批次上傳格式</a>
            </div>
            <div class="col-auto">
              <b-button variant="secondary" class="mr-3" v-if="dataInFile.length > 0" @click="clearData">
                清除
              </b-button>
              <b-button variant="primary" :disabled="dataInFile.length === 0" @click="uploadBtnClicked">
                確認上傳
              </b-button>
            </div>
          </div>
        </div>

        <div class="step-2">

        </div>

      </div>
    </template>
  </b-modal>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import { mapActions } from "vuex";
export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'KegCreateBatchModal',
  data() {
    return {
      dataInFile: [
        // {
        //   kid: 'string',
        //   sizeModel: '30L',
        //   isReused: false,
        //   uploaded: false,
        //   error: false,
        //   errorMsg: '',
        // }
      ],
    };
  },
  components: {
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
      passed: false,
    },
  },
  computed: {
    modalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },

  },
  watch: {
    
  },
  mounted() {
  },
  methods: {
    ...mapActions(['showMsgModal', 'appendComponentBusy', 'clearComponentBusy', 'appendErrorMsg']),
    clearData() {
      this.dataInFile.splice(0);
    },
    async uploadAllData() {
      const busyname = "UPLOADALL";
      this.appendComponentBusy(busyname);
      let uploadedCount = 0;
      for (let i=0;i<this.dataInFile.length;i++) {
        const d = this.dataInFile[i];
        if (d.error || d.uploaded) {
          continue;
        }
        try {
          await this.handleAsyncTask(() => this.$store.dispatch('keg/createKegs', [d]));
          d.uploaded = true;
          uploadedCount += 1;
        } catch (error) {
          d.error = true;
          d.errorMsg = error.toString();
        }
      }
      alert(`成功上傳了 ${uploadedCount} 筆資料`);
      this.clearComponentBusy(busyname);
    },
    async uploadBtnClicked() {
      await this.handleAsyncTask(() => this.uploadAllData());
    },
    inputFileChanged(evt) {
      const f = evt.target.files[0];
      if (f) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const csvData = e.target.result;
          const lines = csvData.split('\n');
          // const headers = lines[0].split(',');

          for (let i = 1; i < lines.length; i++) {
            const row = lines[i].split(',');
            const kid = row[0].trim();
            if (kid.length === 0) {
              continue;
            }
            const obj = {
              kid,
              sizeModel: '',
              isReused: false,
              uploaded: false,
              error: false,
              errorMsg: '',
            };
            try {
              obj.sizeModel = row[1].trim();
              if (obj.sizeModel !== '10L' && obj.sizeModel !== '20L' && obj.sizeModel !== '30L') {
                throw new Error('尺寸不合規格');
              }
              if (row[2].trim() === '1') {
                obj.isReused = false;
              } else if (row[2].trim() === '2') {
                obj.isReused = true;
              }
            } catch (error) {
              obj.error = true;
              obj.errorMsg = error;
            }
            this.dataInFile.push(obj);
          }
        };
        reader.readAsText(f);
        evt.target.value = null;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.info-window {
  padding: 1rem;
  border-radius: 1rem;
  border: dashed 2px $color-primary;
  margin-bottom: 1rem;
  >div {
    max-height: 40vh;
    overflow-y: scroll;
    overflow-x: hidden;
  }
}
</style>
